import useViewsSelector from "views/stores/useViewsSelector";
import { selectIsNew } from "views/logic/slices/viewSelectors";
const useIsNew = () => useViewsSelector(selectIsNew);
export default useIsNew;
